let queryList = [];

export function getObj(query) {
    let obj = document.querySelector(query);
    if (obj) {
        return new Promise((res) => {
            res(obj);
        });
    }
    return new Promise((res) => {
        queryList.push({ query, callback: res, once: true });
    });
}

export function listenForObj(query, callback) {
    let obj = document.querySelector(query);
    if (obj) {
        obj.blSeen = true;
        callback(obj);
    }
    queryList.push({ query, callback, once: false });
}

export const waitForBlockly = () =>
    new Promise((resolve) => {
        const check = () => {
            if (Blockly.getMainWorkspace()) {
                resolve(Blockly.getMainWorkspace());
            } else {
                setTimeout(check, 100);
            }
        };
        check();
    });

export const waitForElement = (selector) =>
    new Promise((resolve) => {
        const check = () => {
            const element = document.querySelector(selector);
            if (element) resolve(element);
            else setTimeout(check, 100);
        };
        check();
    });

export const getGuiInternals = async () => {
    const stageWrapper = await waitForElement(
        'div[class^="stage-wrapper_stage-wrapper_"]',
    );
    const reactInst = Object.values(stageWrapper).find((x) => x?.child);
    const gui = reactInst.child.child.child.stateNode;

    return { vm: gui.props.vm, store: gui.context.store };
};

export const findScratchBlocks = () => {
    const wrapper = document.querySelector('[class^="gui_blocks-wrapper"]');
    if (!wrapper) return null;

    const key = Object.keys(wrapper).find((k) =>
        k.startsWith("__reactInternalInstance"),
    );
    let fiber = key ? wrapper[key] : null;
    while (fiber && !fiber.stateNode?.ScratchBlocks) fiber = fiber.child;

    return fiber?.stateNode?.ScratchBlocks || null;
};

export function isWorkspaceAccesable() {
    return !!document.querySelector(".blocklyWorkspace");
}

export function getWorkspace() {
    let retVal = Blockly.getMainWorkspace();
    if (typeof ScratchBlocks == "undefined") {
        return retVal;
    }
    Object.entries(ScratchBlocks.Workspace.WorkspaceDB_).forEach((wkv) => {
        if (!wkv[1].isFlyout && wkv[1].deleteAreaToolbox_) {
            retVal = wkv[1];
        }
    });
    return retVal;
}

export function getPaper() {
    let paperContainer = document.querySelector(
        "[class^='paint-editor_canvas-container']",
    );
    if (!paperContainer) return null;
    let reactInst;
    for (let e of Object.entries(paperContainer)) {
        if (e[0].startsWith("__reactInternalInstance")) {
            reactInst = e[1];
            break;
        }
    }
    return reactInst?.child?.child?.child?.stateNode;
}

export const getSelectedCostumeIndex = () => {
    const item = document.querySelector(
        "[class*='selector_list-item'][class*='sprite-selector-item_is-selected']",
    );
    if (!item) return -1;
    const numberEl = item.querySelector(
        "[class*='sprite-selector-item_number']",
    );
    if (!numberEl) return -1;
    return +numberEl.textContent - 1;
};

const TOOLBAR_GAP = 12;

const TOOLBAR_CSS = `
    #ls-toolbar {
        position: absolute;
        top: 0;
        left: ${TOOLBAR_GAP}px;
        height: 2.75rem;
        display: flex;
        align-items: center;
        gap: 10px;
        z-index: 30;
    }
`;

export const getFrontendToolbar = () => {
    const existing = document.getElementById("ls-toolbar");
    if (existing) return existing;

    const tabs = document.querySelector('[class^="gui_tabs"]');
    if (!tabs) return null;

    if (!document.getElementById("ls-toolbar-style")) {
        const style = document.createElement("style");
        style.id = "ls-toolbar-style";
        style.textContent = TOOLBAR_CSS;
        document.head.appendChild(style);
    }

    const toolbar = document.createElement("div");
    toolbar.id = "ls-toolbar";
    tabs.appendChild(toolbar);

    const tabList = tabs.querySelector('[class*="gui_tab-list"]');
    if (tabList) {
        const alignAfterTabs = () => {
            const origin = tabs.getBoundingClientRect().left;
            let edge = tabList.getBoundingClientRect().right;

            for (const tab of tabList.children)
                edge = Math.max(edge, tab.getBoundingClientRect().right);

            toolbar.style.left = `${edge - origin + TOOLBAR_GAP}px`;
        };

        const observer = new ResizeObserver(alignAfterTabs);
        observer.observe(tabList);
        for (const tab of tabList.children) observer.observe(tab);
        alignAfterTabs();
    }

    return toolbar;
};
